module.exports = __webpack_public_path__ + "images/recommend_member_male-7751ec57d140127d7d197fb627952ade.svg";